var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.breakpoint=='xs')?_c('IndexCompact',{attrs:{"farmers":_vm.farmers}}):(_vm.partnerCode && _vm.breakpoint !== 'xs')?_c('IndexNormalNile',{attrs:{"farmers":_vm.farmers}}):_c('IndexNormal',{attrs:{"farmers":_vm.farmers}})
}
var staticRenderFns = []

export { render, staticRenderFns }